<template>
    <NuxtLink
        :to="to"
        :aria-label="`Открыть продукцию ${title}`"
        :class="sizeClass"
        class="group relative z-20 block aspect-square rounded-12 bg-[#FFFFFF0D] p-2 max-sm:h-full max-sm:max-h-[10.625rem] max-sm:w-full max-sm:max-w-[12.75rem] md:w-[14rem] md:p-3 lg:w-[20rem] lg:p-5 xl:w-[27.5rem]">
        <div
            class="absolute inset-0 h-full w-full rounded-12 bg-card opacity-0 transition-opacity duration-300 group-hover:opacity-100">
            <div class="bg-noise" />
        </div>
        <p
            class="relative max-w-[16rem] text-16/132 font-semibold lg:text-20/120 xl:text-24/133">
            {{ title }}
        </p>
        <slot />
        <ArrowButton
            :aria-label="`Открыть продукцию ${title}`"
            class="absolute bottom-5 right-5 max-lg:hidden" />
    </NuxtLink>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'

import ArrowButton from '~/components/base/arrow-button/ArrowButton.vue'

const props = defineProps({
    title: {
        type: String,
        default: '',
    },
    size: {
        type: String as PropType<'sm' | 'md'>,
        default: 'sm',
    },
    to: {
        type: String as PropType<string>,
        default: '#',
    },
})

const sizeClass = computed(() => {
    switch (props.size) {
        case 'sm':
            return 'md:h-[12rem] lg:h-[14.25rem]'
        case 'md':
            return 'md:h-[17.5rem] lg:h-[20.125rem]'
        default:
            return ''
    }
})
</script>
